import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAcuityRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.074 20.182c.661.56 3.584.585 4.525.026l2.643-1.856c.102-.102.178-.178.255-.28 1.804-2.414 1.728-5.668-.204-8.007-1.067-1.27-2.44-2.033-4.092-2.236-3.483-.458-6.685 1.957-7.194 5.414a6.07 6.07 0 0 0 .407 3.355q.075.228 0 .458c-.407.915-.813 1.855-1.22 2.796-.026.05-.026.101-.076.178-.077-.026-.127-.102-.153-.153-1.042-1.347-1.601-2.898-1.88-4.575-.103-.763-.026-1.678-.026-1.729.025-.356.05-.686.101-1.017.356-1.982 1.322-3.787 2.796-5.134a9.06 9.06 0 0 1 4.423-2.364 9.5 9.5 0 0 1 1.271-.203 7.7 7.7 0 0 1 1.525 0c.356.025.661.076.992.152 2.821.585 4.931 2.135 6.38 4.626.915 1.627 1.296 3.381 1.17 5.237-.179 2.11-.941 3.965-2.365 5.566l-.635.636-2.085 1.449a8.7 8.7 0 0 1-3.05.965 9.34 9.34 0 0 1-4.855-.686 10 10 0 0 1-.763-.356z",
			fill: "url(#acuity-regular-icon-gradient)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.96 22.444c-.889.915-1.626 1.78-2.11 2.136-.202.127-.406.203-.533.076-.203-.153-.152-.356-.102-.509 1.068-2.465 2.136-4.956 3.203-7.422.026-.076.076-.127.127-.254.737 1.144 1.729 1.855 3.025 2.11l-1.5 1.601zm6.64-2.236c-.052-.076-.103-.127-.153-.178a580 580 0 0 1-3.94-3.965 2.6 2.6 0 0 1-.788-1.881c0-1.22.864-2.288 2.059-2.568a2.616 2.616 0 0 1 2.948 1.398c.814 1.703 1.602 3.407 2.415 5.11.026.05.05.127.102.228l1.398 3.025a238 238 0 0 1 1.728 3.66c.076.153.153.33.229.483.076.128.127.28-.025.382-.153.101-.28.025-.382-.102-1.016-1.042-2.059-2.059-3.075-3.101a.6.6 0 0 1-.128-.102z",
			fill: "#131421"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "acuity-regular-icon-gradient",
			x1: 6.218,
			y1: 14.184,
			x2: 24.55,
			y2: 14.184,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#fde984" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#fda701"
			})]
		}) })
	]
});
export default SvgAcuityRegularIcon;
